import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { TRootState } from '../../reducers';

export default function ContactUs() {
    const {
        contactPhone,
        contactEmail,
        supportEmail,
    } = useSelector((state: TRootState) => ({
        contactPhone: state.user.agency.contact_phone,
        contactEmail: state.user.agency.contact_email,
        supportEmail: state.user.agency.support_email,
    }));

    const renderPhone = useCallback(
        (phone: string) => phone
            ? <a href={`tel:${phone.replace(' ', '')}`}>{phone}</a>
            : 'N/A',
        []
    );

    const renderEmail = useCallback(
        (email: string) => email
            ? <a href={`mailto:${email}`}>{email}</a>
            : 'N/A',
        []
    );

    return (
        <div className="freelancer-details-container">
            <div className="freelancer-details-section__header">
                <div className="freelancer-details-section__title">Contact Us</div>
            </div>
            <div className="freelancer-details-section__content">
                To contact us please call us on {renderPhone(contactPhone)}{' '}
                or you can email us at {renderEmail(supportEmail || contactEmail)}
            </div>
        </div>
    );
}
